/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 应用正则配置文件
 * @Date: 2021-10-18 17:51:22
 * @LastEditTime: 2021-10-18 17:51:22
 */

export default {
  
}